export const GET_CONTENT_SETTINGS_QUERY_KEY = ['contentSettings'] as const;

export const CONTENT_SETTINGS_ENDPOINT =
  '/cart/organization/enrollment_content_settings';
